import * as Yup from "yup";

export class CurvaPrecoFixoSchema {
  public static createForm() {
    const createFormShape = {
      anoMes: Yup
        .string()
        .matches(/^\d{4}-(?:0[1-9]|1[0-2])$/u, "Mês com formato inválido")
        .typeError("Valor inválido para mês")
        .required("Mês é obrigatório"),
      convencional: Yup.number().typeError("Valor inválido para convencional")
        .nullable(),
      i0: Yup.number().typeError("Valor inválido para i0")
        .nullable(),
      i50: Yup.number().typeError("Valor inválido para i50")
        .nullable(),
      i100: Yup.number().typeError("Valor inválido para i100")
        .nullable(),
      cq5: Yup.number().typeError("Valor inválido para cq5")
        .nullable(),
      cq1: Yup.number().typeError("Valor inválido para cq1")
        .nullable(),
      sudeste: Yup.number().typeError("Valor inválido para sudeste")
        .nullable(),
      sul: Yup.number().typeError("Valor inválido para sul")
        .nullable(),
      norte: Yup.number().typeError("Valor inválido para norte")
        .nullable(),
      nordeste: Yup.number().typeError("Valor inválido para nordeste")
        .nullable(),
    };

    return Yup.object().shape(createFormShape);
  }

  public static createBatchForm() {
    const createBatchFormShape = {
      anoMeses: Yup
        .array()
        .of(this.createForm())
        .required(),
    };

    return Yup.object().shape(createBatchFormShape);
  }

  public static createWithSheet() {
    return Yup.array().of(Yup.object().shape({
      "MÊS DE FORNECIMENTO": Yup.date().required(),
      "CONVENCIONAL": Yup.number().nullable(),
      "I0": Yup.number().nullable(),
      "I50": Yup.number().nullable(),
      "I100": Yup.number().nullable(),
      "CQ5": Yup.number().nullable(),
      "CQ1": Yup.number().nullable(),
      "SUDESTE": Yup.number().nullable(),
      "SUL": Yup.number().nullable(),
      "NORTE": Yup.number().nullable(),
      "NORDESTE": Yup.number().nullable(),
    }));
  }
}
